export interface ChangePasswordFields {
  old: string;
  current: string;
  confirm: string;
}

export enum ValidationMessages {
  RequiredField = "login.validations.required_field",
  IdenticalPasswords = "login.validations.identical_passwords",
  DoesNotMeetPolicy = "login.validations.does_not_meet_policy",
  DoNotMatch = "login.validations.do_not_match",
}
